import React, { useEffect, useRef, useState, useCallback } from "react";
import { Box, HStack, VStack } from "@chakra-ui/layout";
import { IPhotoProps, IPhotosProps } from "./photos.types";

export function Photos({
  photos: unsortedPhotos,
  onItemSelectedCb,
  onSelectedTemUrlCb,
  itemSelected,
  itemSelectedUrl,
  getPexelsPhotoData,
  onDragStart,
  onDragEnd,
}: IPhotosProps) {
  const sides: any[][] = [[], []];
  const heightsSum = [0, 0];
  const [selectedData, setSelectedData] = useState(0);
  const [count, setCount] = useState(0);

  for (const photo of unsortedPhotos) {
    if (heightsSum[0] < heightsSum[1]) {
      sides[0].push(photo);
      heightsSum[0] += photo.height / photo.width;
    } else {
      sides[1].push(photo);
      heightsSum[1] += photo.height / photo.width;
    }
  }

  const onSelectedItemClick = useCallback(
    (event: any, counter: any) => {
      setCount(counter);
      setSelectedData(0);
    },
    [selectedData, count]
  );

  const itemClick = (e: any) => {

    const returnJson = {
      action: "create",
      type: "image",
      file: e.target.src,
      thumbnail: itemSelectedUrl.thumbnail
    };

    getPexelsPhotoData(returnJson);

    if (window.vlogr) {
      window.vlogr.addData(1, JSON.stringify(returnJson));
    }
    if (window.webkit) {
      window.webkit.messageHandlers.addData.postMessage(returnJson);
    }
    if (window.top) {
      window.top.postMessage(returnJson, "*");
    }
  };

  return (
    <Box marginInline="auto" maxWidth="fit-content">
      <HStack spacing="8px" align="start">
        <VStack spacing="8px">
          {sides[0] &&
            sides[0].length &&
            sides[0].map((photo: any, i) => {
              const sUrl = photo.src.large;
              const thumbnail = (photo.src.small);
              return (
                <Box key={i} onClick={itemClick}>
                  <Photo
                    thumbnail={thumbnail}
                    urls={sUrl}
                    onSelectedItemClick={onSelectedItemClick}
                    selectedData={selectedData}
                    count={count}
                    onItemSelectedCb={onItemSelectedCb}
                    onSelectedTemUrlCb={onSelectedTemUrlCb}
                    itemSelected={itemSelected}
                    setSelectedData={setSelectedData}
                    itemSelectedUrl={itemSelectedUrl}
                    onDragStart={(event: React.DragEvent<HTMLDivElement>) => {
                      if (onDragStart) {
                        onDragStart(event, {
                          action: "create",
                          type: "image",
                          file: sUrl,
                        });
                      }
                    }}
                    onDragEnd={(
                      event: React.DragEvent<HTMLDivElement>,
                      data: any
                    ) => {
                      onDragEnd(event, data);
                    }}
                  />
                </Box>
              );
            })}
        </VStack>
        <VStack spacing="8px">
          {sides[1] &&
            sides[1].length &&
            sides[1].map((photo: any, i) => {
              const sUrl = photo.src.large;
              const thumbnail = (photo.src.small);
              return (
                <Box key={i} onClick={itemClick}>
                  <Photo
                    thumbnail={thumbnail}
                    urls={sUrl}
                    onSelectedItemClick={onSelectedItemClick}
                    selectedData={selectedData}
                    count={count}
                    onItemSelectedCb={onItemSelectedCb}
                    onSelectedTemUrlCb={onSelectedTemUrlCb}
                    itemSelected={itemSelected}
                    setSelectedData={setSelectedData}
                    itemSelectedUrl={itemSelectedUrl}
                    onDragStart={(event: React.DragEvent<HTMLDivElement>) => {
                      if (onDragStart) {
                        onDragStart(event, {
                          action: "create",
                          type: "image",
                          file: sUrl,
                        });
                      }
                    }}
                    onDragEnd={(
                      event: React.DragEvent<HTMLDivElement>,
                      data: any
                    ) => {
                      onDragEnd(event, data);
                    }}
                  />
                </Box>
              );
            })}
        </VStack>
      </HStack>
    </Box>
  );
}

const Photo = ({
  thumbnail,
  urls,
  onSelectedItemClick,
  selectedData,
  setSelectedData,
  count,
  onItemSelectedCb,
  onSelectedTemUrlCb,
  itemSelected,
  itemSelectedUrl,
  onDragStart,
  onDragEnd,
}: IPhotoProps) => {
  const [isSelected, setSelected] = useState<boolean>(selectedData);
  const playerRef = useRef(null);
  const pVidRef = useRef(null);

  useEffect(() => {
    if (count >= 1) {
      onSelectedItemClick(null, 0);
      setSelected(selectedData);
    }
  }, [isSelected, count, itemSelected]);

  useEffect(() => {
    if (!itemSelected && itemSelectedUrl.item_url == "") {
      setSelectedData(false);
      setSelected(selectedData);
      onSelectedItemClick(null, 0);
    }
  }, [isSelected, selectedData, count, itemSelected, itemSelectedUrl]);

  const handleClick = (e: any) => {
    let counter = count + 1;
    onSelectedItemClick(e, counter);
    setTimeout(() => {
      let url = e.target.src;
      onSelectedTemUrlCb({ item_url: url, item_type: "image", thumbnail: thumbnail });
      setSelected(true);
      onItemSelectedCb(true);
    }, 50);
  };

  return (
    <div
      ref={pVidRef}
      className={isSelected ? "sDiv" : "mDiv"}
      style={{ cursor: "pointer" }}
      onClick={(e) => {
        e.preventDefault();
        handleClick(e);
      }}
    >
      <img
        src={urls}
        onDragStart={(event) => {
          if (onDragStart) {
            onDragStart(event);
          }
        }}
        onDragEnd={(event) => {
          if (onDragEnd) {
            onDragEnd(event, {
              client: {
                x: event.clientX,
                y: event.clientY,
              },
              screen: {
                x: event.screenX,
                y: event.screenY,
              },
              page: {
                x: event.pageX,
                y: event.pageY,
              },
              movement: {
                x: event.movementX,
                y: event.movementY,
              },
            });
          }
        }}
      />
    </div>
  );
};
